<template>
  <div class="content-container">
    <div class="header">
        <GroupsTitle :group="group"/>
    </div>
    <div class="content">
        <div class="tools-container">
            <div class="row space-between bb-2 pb-12 px-16">
                <div class="left-side">
                    <div class="group-expiration">
                        <span>
                            {{toLocal('groups.group_active_till')}}:
                        </span>
                        <date-picker
                            required
                            v-model="deactivationDate"
                            :disabledDate="disabledDates"
                            label="date"
                            :placeholder="toLocal('users_side.select_date')"
                            class="group-expiration-date-picker"
                            :class="{picked: deactivationDate != null && deactivationDate.length > 0}"
                            type="date"
                            valueType="format"
                            @change="handleDeactivation"
                        >
                            <template v-slot:icon-calendar>
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.630608 13.9861L3.88713 13.2565H3.91442C4.0673 13.2563 4.21864 13.2259 4.35976 13.1672C4.50088 13.1084 4.62901 13.0224 4.7368 12.914L13.6559 3.99858C13.8763 3.7773 14 3.47778 14 3.16554C14 2.85331 13.8763 2.55378 13.6559 2.3325L11.6718 0.34396C11.4505 0.123673 11.1508 0 10.8385 0C10.5261 0 10.2265 0.123673 10.0051 0.34396L1.0807 9.26472C0.971378 9.37432 0.885531 9.50503 0.828388 9.64888C0.771246 9.79273 0.744004 9.9467 0.748324 10.1014L0.0151472 13.3713C0.00015831 13.4446 0.00015831 13.5202 0.0151472 13.5936C0.0295181 13.6602 0.0570145 13.7234 0.096036 13.7793C0.135056 13.8352 0.184823 13.8828 0.242432 13.9193C0.325458 13.9718 0.421556 14.0001 0.519817 14.0007C0.557682 14.0015 0.595481 13.9972 0.632237 13.9881M10.522 0.861047C10.6059 0.777507 10.7196 0.730607 10.8381 0.730607C10.9565 0.730607 11.0702 0.777507 11.1541 0.861047L13.1386 2.84918C13.1807 2.89004 13.2141 2.93898 13.2369 2.99306C13.2596 3.04714 13.2712 3.10525 13.271 3.16391C13.2709 3.22289 13.2592 3.28127 13.2364 3.3357C13.2137 3.39013 13.1805 3.43953 13.1386 3.48109L12.2787 4.34059L9.65968 1.72259L10.522 0.861047ZM1.8375 9.54199L9.14238 2.23845L11.7615 4.85645L4.45657 12.16L1.8375 9.54199ZM1.12958 11.7553L1.47458 10.2138L3.79141 12.5297L2.13444 12.8994L1.12958 11.7553Z" fill="#333333"/>
                                    <path d="M4.00813 10.3577C3.96021 10.358 3.91271 10.3486 3.86849 10.3301C3.82426 10.3116 3.78421 10.2845 3.75071 10.2502C3.68231 10.1815 3.6439 10.0886 3.6439 9.99166C3.6439 9.89475 3.68231 9.80179 3.75071 9.73311L9.31145 4.17505C9.34516 4.14065 9.3854 4.11332 9.42982 4.09467C9.47423 4.07602 9.52192 4.06641 9.57009 4.06641C9.61827 4.06641 9.66596 4.07602 9.71037 4.09467C9.75479 4.11332 9.79503 4.14065 9.82874 4.17505C9.89714 4.24372 9.93555 4.33668 9.93555 4.43359C9.93555 4.5305 9.89714 4.62346 9.82874 4.69213L4.268 10.2502C4.23402 10.2845 4.19353 10.3117 4.14891 10.3301C4.10429 10.3486 4.05643 10.358 4.00813 10.3577Z" fill="#333333"/>
                                </svg>

                            </template>
                        </date-picker>
                    </div>
                    <div class="group-supervisor">
                        <span  v-if="group.users_formattedCopy && typeof group.users_formattedCopy === 'object'">
                            {{toLocal('groups.group_supervisor')}}:
                        </span>
                       
                        <GroupSupervisorDropdown
                                v-if="group.users_formattedCopy && typeof group.users_formattedCopy === 'object'"
                                :list="showOnlyGroupUsers ? Object.values(group.users_formattedCopy) : users"
                                key-label="id"
                                value-label="fullName"
                                :compare-list="group.supervisors ? group.supervisors : []"
                                :options="{
                                    closeOnClick: false,
                                    checkbox: true,
                                    customDDWidth: 'calc(100% + 5rem)',
                                    customMaxHeight: '300px',
                                    showOnlyGroupUsers: showOnlyGroupUsers,
                                    initial: group.supervisors && group.supervisors.length == 1 && group.supervisors[0] ? group.supervisors[0].name+ ' ' + (group.supervisors[0].last_name ? group.supervisors[0].last_name : '') : 'groups.group_supervisor',
                                    containerClass: 'groups-table-dropdown supervisor-dropdown',
                                    searchBar: true, 
                                    type: 'groups-supervisor',
                                    searchLocally: true,
                                    showCreateNewBtn:false,
                                    allowOpen: true,
                                    openOnLoad: false,
                                    item_id:group.id
                                }"
                                @search="searchSupervisor($event, group)"
                                @elClicked="saveSupervisor($event, group)"
                                @showOnlyGroupUsers="showOnlyGroupUsers = $event"
                            >
                                <template v-slot:arrow >
                                    <svg v-once width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1.5L6 6.5L11 1.5" stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </template>
                            </GroupSupervisorDropdown>
                    </div>
                </div>
                <div class="right-side invitation" v-if="$store.state.system_settings.showGroupInvitation">
                    <button @click="openInvitationModal" class="add" :class="[getContrast('secondary_color')]">
                    {{toLocal('groups.add_link_invitation')}}
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.27305 5.66883C6.49067 5.66883 5.71863 6.06128 5.20555 6.57893L1.16554 10.7785C0.51283 11.3097 0.258065 12.0986 0.258065 12.8696L0.259105 12.8822C0.387572 14.4375 1.67202 15.7419 3.22813 15.7419C3.87447 15.7419 4.65432 15.4826 5.17884 14.826L7.50194 12.4822C7.59781 12.3854 7.63791 12.2504 7.63791 12.1276C7.63791 12.0047 7.59781 11.8697 7.50194 11.7729C7.40607 11.6762 7.27225 11.6358 7.15047 11.6358C7.0287 11.6358 6.89487 11.6762 6.79901 11.7729L4.47011 14.1226C3.79339 14.8054 2.54029 14.8054 1.86357 14.1226C1.18685 13.4399 1.18685 12.1756 1.86357 11.4928L6.03106 7.28814C6.70778 6.60538 7.96088 6.60538 8.6376 7.28814C8.73347 7.38486 8.8673 7.42532 8.98907 7.42532C9.11084 7.42532 9.24467 7.38486 9.34054 7.28814C9.4364 7.19142 9.47651 7.05639 9.47651 6.93353C9.47651 6.81343 9.43818 6.68171 9.34691 6.5855C8.82034 5.92576 8.03778 5.66883 7.27305 5.66883Z" fill="#4D4D4D"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5362 0.955584C11.799 -0.318528 13.7749 -0.318528 15.0377 0.955584L15.1719 1.09094L15.1769 1.09663C16.2968 2.36771 16.2963 4.22099 15.0377 5.49081L15.0334 5.49514L10.868 9.57406C10.3161 10.1298 9.48208 10.5583 8.61945 10.5583C8.07589 10.5583 7.50983 10.4244 7.06291 10.1307C6.849 10.0143 6.70628 9.82269 6.66904 9.59722C6.63665 9.40118 6.68907 9.20191 6.80903 9.0503C6.88884 8.90538 7.02541 8.729 7.26722 8.6802C7.49599 8.63404 7.70434 8.73359 7.82234 8.79312L7.84513 8.80462L7.8663 8.81886C8.43146 9.199 9.29958 9.10338 9.77585 8.52676L9.79206 8.50714L13.9682 4.2946C14.2508 4.00947 14.401 3.59211 14.401 3.16136C14.401 2.73061 14.2508 2.31325 13.9682 2.02813C13.6858 1.74323 13.2733 1.59245 12.8482 1.59245C12.4231 1.59245 12.0106 1.74323 11.7282 2.02813L11.7209 2.03558L9.27223 4.38236C9.11749 4.53555 8.91373 4.59138 8.74203 4.59138C8.56868 4.59138 8.36253 4.53445 8.20727 4.3778C8.0523 4.22145 7.99653 4.01467 7.99653 3.84153C7.99653 3.66839 8.0523 3.46161 8.20727 3.30526L10.5362 0.955584ZM5.39016 6.75927L1.34063 10.9687L1.32844 10.9786C0.755398 11.4451 0.51843 12.1451 0.516146 12.8591L0.516294 12.8609C0.634904 14.2969 1.82038 15.4839 3.22813 15.4839C3.81272 15.4839 4.51122 15.2483 4.97721 14.6649L4.98583 14.6541L7.31865 12.3005C7.35541 12.2634 7.37985 12.2001 7.37985 12.1276C7.37985 12.055 7.35541 11.9917 7.31865 11.9546C7.28219 11.9178 7.22068 11.8938 7.15047 11.8938C7.08027 11.8938 7.01876 11.9178 6.98229 11.9546L4.6534 14.3043C4.25906 14.7022 3.70666 14.8928 3.16684 14.8928C2.62702 14.8928 2.07463 14.7022 1.68028 14.3043C1.28617 13.9067 1.09797 13.3505 1.09797 12.8077C1.09797 12.265 1.28617 11.7088 1.68028 11.3112L5.84777 7.10647C6.24212 6.70861 6.79451 6.518 7.33433 6.518C7.87415 6.518 8.42655 6.70861 8.82089 7.10647C8.85736 7.14326 8.91887 7.16726 8.98907 7.16726C9.05927 7.16726 9.12078 7.14326 9.15725 7.10647C9.19401 7.06938 9.21844 7.00611 9.21844 6.93353C9.21844 6.8628 9.19514 6.80048 9.1597 6.76312L9.1521 6.75511L9.14522 6.74649C8.68075 6.16455 7.98307 5.92689 7.27305 5.92689C6.57271 5.92689 5.86438 6.28148 5.39016 6.75927ZM5.02227 6.39726C5.57418 5.84042 6.40928 5.41076 7.27305 5.41076C8.08958 5.41076 8.9538 5.68502 9.54235 6.4167C9.68322 6.57051 9.73457 6.76726 9.73457 6.93353C9.73457 7.10667 9.67879 7.31345 9.52383 7.4698C9.36856 7.62645 9.16242 7.68338 8.98907 7.68338C8.81573 7.68338 8.60958 7.62645 8.45432 7.4698C8.17194 7.18491 7.75942 7.03413 7.33433 7.03413C6.90924 7.03413 6.49673 7.18491 6.21435 7.4698L2.04686 11.6745C1.76426 11.9596 1.6141 12.377 1.6141 12.8077C1.6141 13.2385 1.76426 13.6558 2.04686 13.941C2.32924 14.2259 2.74175 14.3766 3.16684 14.3766C3.59193 14.3766 4.00445 14.2259 4.28683 13.941L6.61572 11.5913C6.77098 11.4346 6.97713 11.3777 7.15047 11.3777C7.32382 11.3777 7.52996 11.4346 7.68523 11.5913C7.8402 11.7476 7.89597 11.9544 7.89597 12.1276C7.89597 12.3007 7.8402 12.5075 7.68523 12.6638L5.3716 14.9981C4.78872 15.7198 3.93264 16 3.22813 16C1.52366 16 0.140239 14.5781 0.00191636 12.9034L0 12.8802V12.8696C0 12.0501 0.26994 11.1821 0.990165 10.5886L5.02227 6.39726Z" fill="#4D4D4D"/>
                        </svg>
                    </button>
                </div>
            </div>
            <div class="row newly-added-group" v-if="group.newly_added">
                <div class="newly-added-group-wrapper">
                    <span class="text-label">{{toLocal('groups.how_to_add_users')}}</span>
                    <div class="button-container">
                        <button @click="setUserSelectionMode(0)">{{toLocal('groups.add_users_by_one')}}</button>
                        <button @click="setUserSelectionMode(1)">{{toLocal('groups.add_users_using_condition')}}</button>
                    </div>
                </div>
            </div>
            <div class="row bb-2 pb-12 px-16" v-if="!group.newly_added && group.user_selection_mode == 1">
                <div class="condition-container">
                    <span class="label">{{toLocal('groups.add_users_with_this_condition')}}:</span>
                    <ConditionFilter  
                        :groupUserFilter="groupUserFilter" 
                        :includable_columns="includable_columns"
                        :groups="groups" 
                        :user_data="user_data" 
                        :group="group" 
                        :level="0" 
                        @filterEvent="saveFilter"
                    />
                </div>
            </div>
            <div class="row space-between pt-16 pb-24 px-16" v-if="!group.newly_added" >
                <div class="left">
                    <div class="search-bar">
                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="path-1-inside-1_2428_2888" fill="white"><path d="M14.6044 15.1024C14.4784 15.2285 14.3288 15.3285 14.1641 15.3967C13.9995 15.4649 13.823 15.5 13.6447 15.5C13.4665 15.5 13.29 15.4649 13.1254 15.3967C12.9607 15.3285 12.8111 15.2285 12.6851 15.1024L8.63789 11.0562C8.37804 11.2138 8.10574 11.3499 7.82371 11.4632C6.60672 11.9552 5.25699 12.0114 4.00328 11.6223C2.74956 11.2332 1.66898 10.4227 0.944643 9.3281C0.22031 8.23355 -0.103214 6.92228 0.0288984 5.61651C0.161011 4.31075 0.740633 3.09081 1.66954 2.16344C2.59844 1.23608 3.81949 0.658319 5.12575 0.528086C6.43201 0.397855 7.74313 0.723158 8.83692 1.44887C9.93071 2.17458 10.7399 3.25605 11.1273 4.51002C11.5148 5.76398 11.4566 7.11331 10.9628 8.32932C10.8498 8.60906 10.7136 8.87887 10.5557 9.1359L14.6044 13.1829C14.8578 13.4375 15 13.782 15 14.1412C15 14.5003 14.8578 14.8449 14.6044 15.0995M2.48193 9.38972C3.22332 10.1311 4.19889 10.5924 5.2424 10.6953C6.28591 10.7981 7.33279 10.5359 8.20466 9.95353C9.07652 9.37113 9.7194 8.5045 10.0238 7.50132C10.3281 6.49813 10.2751 5.42047 9.87381 4.45198C9.47249 3.48348 8.74767 2.68408 7.82287 2.18999C6.89807 1.6959 5.83052 1.5377 4.80213 1.74235C3.77373 1.947 2.84814 2.50183 2.18307 3.3123C1.518 4.12277 1.15461 5.13873 1.15482 6.18704C1.15498 7.38829 1.63234 8.54029 2.48193 9.38972Z"/></mask><path d="M14.6044 15.1024C14.4784 15.2285 14.3288 15.3285 14.1641 15.3967C13.9995 15.4649 13.823 15.5 13.6447 15.5C13.4665 15.5 13.29 15.4649 13.1254 15.3967C12.9607 15.3285 12.8111 15.2285 12.6851 15.1024L8.63789 11.0562C8.37804 11.2138 8.10574 11.3499 7.82371 11.4632C6.60672 11.9552 5.25699 12.0114 4.00328 11.6223C2.74956 11.2332 1.66898 10.4227 0.944643 9.3281C0.22031 8.23355 -0.103214 6.92228 0.0288984 5.61651C0.161011 4.31075 0.740633 3.09081 1.66954 2.16344C2.59844 1.23608 3.81949 0.658319 5.12575 0.528086C6.43201 0.397855 7.74313 0.723158 8.83692 1.44887C9.93071 2.17458 10.7399 3.25605 11.1273 4.51002C11.5148 5.76398 11.4566 7.11331 10.9628 8.32932C10.8498 8.60906 10.7136 8.87887 10.5557 9.1359L14.6044 13.1829C14.8578 13.4375 15 13.782 15 14.1412C15 14.5003 14.8578 14.8449 14.6044 15.0995M2.48193 9.38972C3.22332 10.1311 4.19889 10.5924 5.2424 10.6953C6.28591 10.7981 7.33279 10.5359 8.20466 9.95353C9.07652 9.37113 9.7194 8.5045 10.0238 7.50132C10.3281 6.49813 10.2751 5.42047 9.87381 4.45198C9.47249 3.48348 8.74767 2.68408 7.82287 2.18999C6.89807 1.6959 5.83052 1.5377 4.80213 1.74235C3.77373 1.947 2.84814 2.50183 2.18307 3.3123C1.518 4.12277 1.15461 5.13873 1.15482 6.18704C1.15498 7.38829 1.63234 8.54029 2.48193 9.38972Z" fill="#7D7D7D"/><path d="M13.6447 15.5L13.6447 16.5L13.6447 15.5ZM12.6851 15.1024L13.3923 14.3955L13.3921 14.3953L12.6851 15.1024ZM8.63789 11.0562L9.34492 10.349L8.7901 9.7943L8.1193 10.2012L8.63789 11.0562ZM7.82371 11.4632L7.45103 10.5352L7.44889 10.5361L7.82371 11.4632ZM10.9628 8.32932L10.0362 7.95303L10.0355 7.95492L10.9628 8.32932ZM10.5557 9.1359L9.7037 8.61231L9.29029 9.28498L9.84871 9.84316L10.5557 9.1359ZM14.6044 13.1829L15.3132 12.4775L15.3113 12.4757L14.6044 13.1829ZM15 14.1412L16 14.1412L15 14.1412ZM1.15482 6.18704L2.15482 6.18691L2.15482 6.18684L1.15482 6.18704ZM13.8971 14.3955C13.864 14.4286 13.8247 14.4549 13.7814 14.4728L14.5469 16.3205C14.8329 16.202 15.0927 16.0284 15.3116 15.8094L13.8971 14.3955ZM13.7814 14.4728C13.7381 14.4908 13.6916 14.5 13.6447 14.5L13.6447 16.5C13.9543 16.5 14.2609 16.439 14.5469 16.3205L13.7814 14.4728ZM13.6447 14.5C13.5979 14.5 13.5514 14.4908 13.5081 14.4728L12.7426 16.3205C13.0286 16.439 13.3352 16.5 13.6447 16.5L13.6447 14.5ZM13.5081 14.4728C13.4648 14.4549 13.4255 14.4286 13.3923 14.3955L11.9779 15.8094C12.1968 16.0284 12.4566 16.202 12.7426 16.3205L13.5081 14.4728ZM13.3921 14.3953L9.34492 10.349L7.93087 11.7634L11.9781 15.8096L13.3921 14.3953ZM8.1193 10.2012C7.90602 10.3305 7.68252 10.4422 7.45103 10.5352L8.1964 12.3911C8.52897 12.2576 8.85007 12.0971 9.15649 11.9112L8.1193 10.2012ZM7.44889 10.5361C6.44573 10.9416 5.33314 10.988 4.2997 10.6672L3.70685 12.5774C5.18084 13.0348 6.7677 12.9687 8.19853 12.3903L7.44889 10.5361ZM4.2997 10.6672C3.26626 10.3465 2.37559 9.6784 1.77858 8.77624L0.110709 9.87997C0.962365 11.1669 2.23286 12.1199 3.70685 12.5774L4.2997 10.6672ZM1.77858 8.77624C1.18157 7.87409 0.914935 6.79335 1.02382 5.71718L-0.966022 5.51585C-1.12136 7.0512 -0.740951 8.593 0.110709 9.87997L1.77858 8.77624ZM1.02382 5.71718C1.1327 4.641 1.61042 3.63551 2.37606 2.87114L0.963014 1.45575C-0.129151 2.54611 -0.810682 3.9805 -0.966022 5.51585L1.02382 5.71718ZM2.37606 2.87114C3.1417 2.10675 4.14819 1.63051 5.22495 1.52315L5.02654 -0.46698C3.49079 -0.313868 2.05518 0.365396 0.963014 1.45575L2.37606 2.87114ZM5.22495 1.52315C6.30172 1.4158 7.38248 1.68396 8.28406 2.28214L9.38978 0.615593C8.10378 -0.237643 6.56229 -0.620093 5.02654 -0.46698L5.22495 1.52315ZM8.28406 2.28214C9.18564 2.88032 9.85257 3.77171 10.1719 4.80522L12.0828 4.21482C11.6272 2.74039 10.6758 1.46883 9.38978 0.615593L8.28406 2.28214ZM10.1719 4.80522C10.4912 5.83872 10.4433 6.9508 10.0363 7.95303L11.8893 8.7056C12.4699 7.27581 12.5383 5.68925 12.0828 4.21482L10.1719 4.80522ZM10.0355 7.95492C9.94343 8.18292 9.83245 8.40281 9.7037 8.61231L11.4076 9.6595C11.5948 9.35492 11.7562 9.03521 11.89 8.70371L10.0355 7.95492ZM9.84871 9.84316L13.8974 13.8902L15.3113 12.4757L11.2626 8.42865L9.84871 9.84316ZM13.8956 13.8883C13.9625 13.9556 14 14.0465 14 14.1412L16 14.1412C16 13.5176 15.753 12.9195 15.3132 12.4775L13.8956 13.8883ZM14 14.1412C14 14.2359 13.9625 14.3268 13.8956 14.3941L15.3132 15.8049C15.753 15.3629 16 14.7648 16 14.1412L14 14.1412ZM1.77485 10.0968C2.67984 11.0018 3.87065 11.5649 5.14435 11.6904L5.34044 9.70007C4.52712 9.61994 3.7668 9.26034 3.18902 8.68259L1.77485 10.0968ZM5.14435 11.6904C6.41805 11.8159 7.69589 11.496 8.76012 10.7851L7.64919 9.12199C6.9697 9.57589 6.15377 9.7802 5.34044 9.70007L5.14435 11.6904ZM8.76012 10.7851C9.82435 10.0742 10.6091 9.01628 10.9807 7.79165L9.06684 7.21099C8.82966 7.99272 8.32868 8.6681 7.64919 9.12199L8.76012 10.7851ZM10.9807 7.79165C11.3522 6.56701 11.2875 5.25145 10.7976 4.06916L8.94999 4.83479C9.26272 5.5895 9.30401 6.42926 9.06684 7.21099L10.9807 7.79165ZM10.7976 4.06916C10.3077 2.88688 9.42294 1.91108 8.2941 1.30798L7.35164 3.072C8.0724 3.45708 8.63725 4.08008 8.94999 4.83479L10.7976 4.06916ZM8.2941 1.30798C7.16527 0.704881 5.86221 0.511789 4.60695 0.761582L4.9973 2.72312C5.79883 2.56362 6.63088 2.68692 7.35164 3.072L8.2941 1.30798ZM4.60695 0.761582C3.3517 1.01138 2.22187 1.68861 1.41003 2.67795L2.95611 3.94666C3.4744 3.31505 4.19577 2.88262 4.9973 2.72312L4.60695 0.761582ZM1.41003 2.67795C0.598177 3.66728 0.15456 4.9075 0.154817 6.18725L2.15482 6.18684C2.15465 5.36996 2.43782 4.57826 2.95611 3.94666L1.41003 2.67795ZM0.154817 6.18718C0.155012 7.65366 0.737783 9.05999 1.7749 10.0969L3.18897 8.68255C2.5269 8.0206 2.15494 7.12292 2.15482 6.18691L0.154817 6.18718Z" fill="#7D7D7D" mask="url(#path-1-inside-1_2428_2888)"/></svg>
                        <svg class="clear-btn" @click="searchingInput=''" v-if="searchingInput && searchingInput.length > 0" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.219653 0.470943C0.512536 0.17804 0.98741 0.178024 1.28031 0.470908L11.2777 10.4676C11.5706 10.7605 11.5706 11.2354 11.2777 11.5283C10.9848 11.8212 10.5099 11.8212 10.217 11.5283L0.219687 1.5316C-0.0732155 1.23872 -0.0732311 0.763846 0.219653 0.470943Z" fill="#7D7D7D"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2803 0.4696C11.5732 0.762454 11.5733 1.23733 11.2804 1.53026L1.28305 11.5303C0.990196 11.8232 0.515323 11.8233 0.222391 11.5304C-0.0705414 11.2375 -0.0706043 10.7627 0.22225 10.4697L10.2196 0.46974C10.5125 0.176808 10.9873 0.176745 11.2803 0.4696Z" fill="#7D7D7D"/>
                        </svg>
                        <input
                            ref="groupSearch"
                            type="text"
                            :placeholder="toLocal('generic.search')"
                            v-model="searchingInput"
                        />
                    </div>
                    <span class="users-connected">
                        {{toLocal('payments.user_count')}}: <span class="strong">{{users ? users.length : '-'}}</span>
                    </span>
                    <span class="users-connected">
                        {{toLocal('groups.users_added')}}: <span class="strong">{{group.user_selection_mode==1 ? userCount : group.users ? group.users.length : group.user_count ? group.user_count : '-'}}</span>
                    </span>
                </div>
                <div class="right" v-if="group.user_selection_mode != 1">
                    <span>
                        {{toLocal('groups.show_these_users')}}:
                    </span>
                    <div class="filter-container">
                        <CustomDropdown
                        v-if="filter"
                        class="c-dropdown"
                        :list="filter"
                        key-label="id"
                        value-label="label"
                        :compare-list="[{id:selectedFilter}]"
                        :options="{
                            closeOnClick: true,
                            checkbox: false,
                            customDDWidth: '100%',
                            customMaxHeight: '300px',
                            initial: filter.find(el=>el.id == selectedFilter).label,
                            containerClass: 'groups-users-filter-dropdown '+getContrast(),
                            searchBar: false,
                            showCreateNewBtn:false
                        }"
                        @elClicked="selectFilter($event)"
                    >
                        <template v-slot:arrow >
                          
                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.933058 1.05806C1.17714 0.813981 1.57286 0.813981 1.81694 1.05806L6.375 5.61612L10.9331 1.05806C11.1771 0.813981 11.5729 0.813981 11.8169 1.05806C12.061 1.30214 12.061 1.69786 11.8169 1.94194L6.81694 6.94194C6.57286 7.18602 6.17714 7.18602 5.93306 6.94194L0.933058 1.94194C0.688981 1.69786 0.688981 1.30214 0.933058 1.05806Z" fill="white"/>
                            </svg>
                        </template>
                    </CustomDropdown>
                    </div>
                </div>
            </div>
            <GroupUserTable 
            v-if="!group.newly_added" class="px-16" :group="group" 
            :selectedFilter="selectedFilter" 
            :users="users" 
            :searchInput="searchingInput" 
            @UserCountFiltered="userCount=$event" 
            @updateGroupUsers="(group_id, user_ids) => $emit('updateGroupUsers', group_id, user_ids)"
            @updateGroupUser="(group_id, user, action) => $emit('updateGroupUser', group_id, user, action)"
            />
            <GroupInvitationModal 
                v-if="invitationModal.show"
                :item="group"
                @close="$set(invitationModal, 'show', false)"
            />
        </div>
    </div>
  </div>

</template>

<script>
import CustomDropdown from "@/components/layout/elements/CustomDropdown.vue";
import GroupUserTable from "@/components/layout/groups/GroupUserTable.vue";
import ConditionFilter from "@/components/layout/groups/ConditionFilter.vue";
import GroupsTitle from "@/components/layout/groups/GroupsTitle.vue";
import GroupInvitationModal from "@/components/layout/groups/GroupInvitationModal.vue";
import GroupSupervisorDropdown from "@/components/layout/elements/GroupSupervisorDropdown.vue";

import DatePicker from "vue2-datepicker";
import moment from "moment";
import axios from 'axios';
export default {
    props:{
        group:Object,
        groups: Array,
        users: Array,
        groupUserFilter: Array,
        user_data: Array,
        includable_columns: Array
    },
    components:{
        CustomDropdown,
        GroupUserTable,
        ConditionFilter,
        GroupsTitle,
        GroupInvitationModal,
        DatePicker,
        GroupSupervisorDropdown
    },
    data(){
        return{
            groupExpirationDate: '',
            searchingInput: '',
            deactivationDate: this.group.deactivation_date,
            filter:[
                {id:1, label: this.toLocal('groups.only_not_added_users')},
                {id:2, label: this.toLocal('groups.only_added_users')},
                {id:3, label: this.toLocal('test_check.filter_users_all')},
            ],
            selectedFilter: 2,
            userCount: 0,
            invitationModal: {
                show: false,
            },
            showOnlyGroupUsers: true
        }
    },
    watch:{
        group(newVal){
            if (newVal.deactivation_date != null) {
                this.deactivationDate = newVal.deactivation_date;
                if(this.group.name_set != undefined && !this.group.name_set){
                    this.$set(this.group,'name', '');
                }
            }
        }
    },
    mounted(){
        this.$set(this.group,'users_formattedCopy',this._.cloneDeep(this.group.users_formatted ));
    },
    methods:{
        openInvitationModal(){
            this.$set(this.invitationModal,'show',true)
        },
        disabledDates(time){
            var date = moment(String(time)).format('YYYY-MM-DD');
            var d1 =moment().format('YYYY-MM-DD');
            if (date>=d1) {
                return false;
            }
            else return true;
        },
        searchSupervisor(input){
            if(input == null){
                this.group.users_formattedCopy = this._.cloneDeep(this.group.users_formatted);
            }
            else{
                this.group.users_formattedCopy = this.group.users_formattedCopy.filter((t) => {
                    return (t.name.toLowerCase()+' '+t.last_name.toLowerCase()).trim().includes(input.toLowerCase());
                });
            }
        },
        
        setUserSelectionMode(mode){
             axios.post( 
                `${this.$store.state.api_link}/group/${this.group.id}/save/user_selection_mode`,
                {
                    mode: mode
                },
                this.$store.getters.axiosConfig()
            ).then((response) => {
                this.$set(this.group, 'newly_added', false);
                this.$set(this.group, 'user_selection_mode', mode);
                
            }).catch((error) => {
                console.log(error)
            });
        },
     
        selectFilter(event){
            this.selectedFilter = event;
        },
        saveSupervisor(event, group) {
             if(group['supervisors']){
                let index = group['supervisors'].findIndex(el => el.id == event);
                if(index != -1){
                    group['supervisors'].splice(index, 1);
                }else{
                    let user = this.users.findIndex(el => el.id == event);
                    if(user != -1){
                        group['supervisors'].push(this.users[user]);
                    }
                }
            }else{
                let user = this.users.findIndex(el => el.id == event);
                if(user != -1){
                    group['supervisors'].push(this.users[user]);
                }
            }
            this.$set(group, 'supervisors', group['supervisors']);
            axios.post( 
                `${this.$store.state.api_link}/group/${group.id}/save/supervisor`,
                {
                    supervisors: group['supervisors'].map(el => el.id),
                },
                this.$store.getters.axiosConfig()
            ).then((response) => {

            }).catch((error) => {
                console.log(error)
            });
        },
        handleDeactivation() {
            if (this.deactivationDate == "" || this.deactivationDate == null) {
                this.clearDeactivationDate();
            } else {
                this.setDeactivationDate();
            }
        },
        setDeactivationDate() {
            if (this.deactivationDate != "") {
                axios
                .post(
                    `${this.$store.state.api_link}/group/deactivationDate/${this.group.id}`,
                    { deactivationDate: this.deactivationDate },
                    this.$store.getters.axiosConfig()
                )
                .then((response) => {})
                .catch((error) => {
                    console.log(error);
                });
            }
        },
        clearDeactivationDate() {
            axios
                .delete(
                    `${this.$store.state.api_link}/group/deactivationDate/${this.group.id}`,
                    this.$store.getters.axiosConfig()
                )
                .then((response) => {})
                .catch((error) => {
                console.log(error);
                });
        },
        saveFilter(filter){
            this.selectedFilter=filter
        }
    }
}
</script>

<style lang="scss" scoped>
.content-container{
    display: flex;
    flex-direction: column;
    color: #333;
    font-family: var(--main-site-font);
    font-size: 14px;
    font-style: normal;
    overflow: hidden;
    height: 100%;
    font-weight: 400;
}
.content{
    overflow: hidden;
    height: 100%;
}
.header{
    display: flex;
    padding: 0 16px;
    margin-bottom: 24px;
}
.groups-table-dropdown{
    background: none;
    border-radius: 6px;
    border: 1px solid #B2B2B2;
    background: none;
    max-width: 12rem;
    min-width: 180px;
    .initial{
        svg{
        }
    }
    &:not(.no-padding-no-bg){
        background: none;
        color: #333;
        .dropdown-initial{
            color: #333;
        }
    }
}
.tools-container{
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;
}
.row{
    display: flex;
    flex-direction: row;
}
.px-16{
    padding-left: 16px;
    padding-right: 16px;
}
.space-between{
    justify-content: space-between;
}
.bb-2{
    border-bottom: 2px solid #E9E9E9;
}
 .search-bar{
    position: relative;
    display: flex;
    align-items: center;
    border-radius: 20px;
    border: 1px solid #B2B2B2;;
    color: #4D4D4D;
    width: 180px;
    input{
      background: none;
      border: none;
      height: 100%;
      width: 100%;
      color: #4D4D4D;
      font-family: var(--main-site-font);
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
      padding: 4px 24px 4px 0;
      &:focus{
        outline: none;
      }
    }
    svg{
      margin: 0 8px;
    }
    .clear-btn{
        position: absolute;
        right: 8px;
        top: 0;
        bottom: 0;
        margin: auto;
        cursor: pointer;
    }
  }
  .users-connected{
    display: flex;
    .strong{
        font-weight: 600;
        margin-left: 5px;
    }
  }
  .group-supervisor{
    display: flex;
    flex-direction: column;
    gap: 8px
  }
  .left,.right{
    display: flex;
    align-items: center;
  }
  .left{
    gap: 12px;
  }
  .right{
    gap: 8px
  }
  .group-expiration{
    display: flex;
    flex-direction: column;
    gap: 8px
  }
  .pb-12{
    padding-bottom: 12px;
  }
  .pt-16{
    padding-top: 16px;
  }
  .pb-24{
    padding-bottom: 24px;
  }
  .groups-users-filter-dropdown{
    min-width: 180px;
    border-radius: 6px;
    background: #4D4D4D;
    padding: 4px 8px;
    color: white;
    .dropdown-extended .dropdown-option span{
        max-width: 100%;
    }
   
  }
  .label{
    display: flex;
    margin: 16px 0 12px 0;
    overflow: hidden;
    color: #333;
    text-overflow: ellipsis;
    font-family: var(--main-site-font);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 142.857% */
  }
  .newly-added-group{
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    .newly-added-group-wrapper{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .text-label{
            color: #333;
            text-align: center;
            font-family: var(--main-site-font);
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            line-height: 26px; /* 144.444% */
        }
        .button-container{
            display: flex;
            margin-top: 24px;
            gap: 28px;
            align-items: center;
            button{
                display: flex;
                justify-content: center;
                min-width: 200px;
                border-radius: 44px;
                background: var(--secondary-color);
                color: #333;
                text-align: center;
                font-family: var(--main-site-font);
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: 24px; /* 150% */
                padding: 6px 15px;
                box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.12);
                cursor: pointer;
                user-select: none;
                border:none;
            }
        }
    }
  }
button{
    display: flex;
    justify-content: center;
    min-width: 200px;
    border-radius: 44px;
    background: var(--secondary-color);
    color: #333;
    text-align: center;
    font-family: var(--main-site-font);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
    padding: 6px 15px;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.12);
    cursor: pointer;
    user-select: none;
    border:none;
}
.left-side,.right-side{
    display: flex;
    align-items: center;
}
.right-side{
    &.invitation{
        button{
            align-items: center;
            gap: 8px;
            &.whiteContrast{
                color: white;
                svg{
                    path{
                        fill: white;
                    }
                }
            }
            &.blackContrast{
                color: #333;
                svg{
                    path{
                        fill: #333;
                    }
                }
            }
        }
    }
}
.left-side{
    gap: 48px;
}
.groups-table-dropdown{
    background: none;
    border-radius: 6px;
    border: 1px solid #B2B2B2;
    background: none;
    max-width: 12rem;
    &:not(.no-padding-no-bg){
        background: none;
        color: #333;
        .dropdown-initial{
            color: #333;
        }
    }
    .initial{
        svg{
        }
    }
}
</style>
<style lang="scss">
.groups-users-filter-dropdown{
    &.dropdown-container .dropdown-extended .dropdown-option span{
        max-width: 100%;
        font-size: 14px;
    }
    &.whiteContrast{
      color: white;
      .dropdown-initial {
        color: white;
      }
    }
}
.group-expiration-date-picker{
    &.mx-datepicker{
        width: 140px;
    }
    &.picked{
        &.mx-datepicker{
            width: 120px;
        }
    }
    .mx-input{
        border: 1px solid #B2B2B2;
        border-radius: 6px;
        height: 28px;
    }
    .mx-input-wrapper .mx-icon-calendar{
        display: flex;
    }
}
</style>